<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <button
    mat-button
    type="button"
    class="qaroni-close-icon"
    [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
  </button>
  <div class="mat-mdc-dialog-title" i18n>Editar etiqueta</div>
  <mat-dialog-content>
    <div class="grid w-full grid-cols-12 gap-3">
      <!-- name -->
      <div class="col-span-12 md:col-span-8">
        <mat-form-field appearance="outline">
          <mat-label i18n>Nombre</mat-label>
          <input
            matInput
            formControlName="name"
            autocomplete="off"
            type="text" />
          @if (InputValidation.checkInputErrors(name)) {
            <mat-error align="start">
              <qaroni-input-error-messages [fc]="name" />
            </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- color -->
      <div class="col-span-12 md:col-span-4">
        <mat-form-field appearance="outline">
          <mat-label i18n>Color</mat-label>
          <mat-select formControlName="color">
            @for (color of TagColorArray; track color) {
              <mat-option [value]="color" class="w-full">
                <div
                  class="color"
                  [style]="{ 'background-color': color, color: color }">
                  {{ color }}
                </div>
              </mat-option>
            }
          </mat-select>
          <span matIconPrefix>
            <mat-icon class="mx-1" [style]="{ color: color.value }"
              >circle</mat-icon
            >
          </span>
          <mat-hint i18n>Color hexadecimal</mat-hint>
          @if (InputValidation.checkInputErrors(color)) {
            <mat-error align="start">
              <qaroni-input-error-messages [fc]="color" />
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <div class="flex w-full items-center justify-center gap-3">
      <button
        mat-flat-button
        color="light-blue"
        class="qaroni-rounded-button m-1"
        type="button"
        [mat-dialog-close]="false"
        i18n>
        Cancelar
      </button>

      <button
        mat-flat-button
        color="blue"
        class="qaroni-rounded-button m-1"
        type="submit"
        [disabled]="!validatedForm">
        <mat-icon class="me-1">save</mat-icon>
        <ng-container i18n>Actualizar</ng-container>
      </button>
    </div>
  </mat-dialog-actions>
</form>
